module.exports = __webpack_public_path__ + "media/public/img/facebook-round-01-50ddc191f871d4ecdbe8252d2011563a.svg";